import { render, staticRenderFns } from "./downloadTender.vue?vue&type=template&id=bbb120ce&scoped=true"
import script from "./downloadTender.vue?vue&type=script&lang=js"
export * from "./downloadTender.vue?vue&type=script&lang=js"
import style0 from "./downloadTender.vue?vue&type=style&index=0&id=bbb120ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb120ce",
  null
  
)

export default component.exports